import axios, { AxiosRequestConfig } from "axios";

import { isEmpty } from "./utils";

export const fetchApi = axios.create();
export const getData = <Data>(url: string, config?: AxiosRequestConfig) => {
  const request = fetchApi
    .get<Data>(url, {
      ...config,
    })
    .then((res) => res.data)
    .catch((err) => {
      if (!axios.isCancel(err)) {
        throw err;
      }
    });
  return request as Promise<Data>;
};

export const mergeParam = (currentPath: string, input: Record<string, string | number>) => {
  const newString = [];
  for (const [fieldName, value] of Object.entries(input)) {
    if (!isEmpty(value)) {
      newString.push(`${fieldName}=${value}`);
    }
  }

  return `${currentPath}?${newString.join("&")}`;
};
